// Параметры запроса списка лидов. Быстрый поиск лежит в адресе как `all` (так же, как у клиентов и сделок),
// а бэк ждёт его в `q`. Пустая строка в запрос не попадает.
export const leadsQuery = (params = {}) => {
  const { all, ...rest } = params;
  const text = typeof all === 'string' ? all.trim() : '';
  return text ? { ...rest, q: text } : rest;
};
